import React, { useState } from 'react';
import ReactPlayer from 'react-player/lazy';
import { Link } from "react-router-dom";
import SectionTitle from "../SectionTitles/SectionTitle";
import testimonials from '../../data/Testimonials/testimonials.json';

// Shows the first 6 testimonial videos from data/Testimonials/testimonials.json.
// A non-empty "caption" renders under the video.
const GalleryContentShort = ({ classes }) => {
    // State to track whether each video is playing
    const [playing, setPlaying] = useState({});

    // Function to handle play on click
    const handlePlay = (key) => {
        setPlaying((prev) => ({ ...prev, [key]: true }));
    };

    return (
        <section className={`mini-gallery-section ${classes}`} id="work">
            <div className="container">
                <div className="row">
                    {/* Heading */}
                    <div className="more-about-us col-md-8 col-sm-12">
                        <SectionTitle title="More About Us" />
                    </div>
                    {/* End: Heading */}

                    <div className="title-wrapper col-md-8 col-sm-12">
                        <div className="team_video_title">
                            <span className="why_chs_icon"><i className="arrow_carrot-down_alt"></i></span>
                            <h5>Our Team And Storage</h5>
                        </div>
                    </div>
                    <div className="row team-video">
                        <div className="col-md-6 col-sm-12">
                            <video
                                src={process.env.PUBLIC_URL + '/assets/videos/sec-video.mp4'}
                                controls={true}
                                type="video/mp4"
                                preload="none"
                                className="video-item"
                                poster={process.env.PUBLIC_URL + '/assets/images/sec-video-thumb.jpg'}
                            />
                        </div>
                    </div>

                    <div className="title-wrapper col-md-8 col-sm-12">
                        <div className="team_video_title">
                            <span className="why_chs_icon"><i className="arrow_carrot-down_alt"></i></span>
                            <h5>Customer Testimonials</h5>
                        </div>
                    </div>
                    <div className="projects-list">
                        {testimonials.slice(0, 6).map((testimonial) => (
                            <div className="col-md-4 col-sm-12" key={testimonial.id}>
                                <div className="single-project-item">
                                    <ReactPlayer
                                        url={testimonial.url}
                                        width="100%"
                                        height="280px"
                                        controls
                                        playing={playing[testimonial.id]}
                                        light={true} // Show thumbnail until clicked
                                        onClick={() => handlePlay(testimonial.id)} // Trigger play on first click
                                    />
                                    {testimonial.caption && (
                                        <p className="testimonial-caption">{testimonial.caption}</p>
                                    )}
                                </div>
                            </div>
                        ))}

                        <div className="slider_btn">
                            <Link to={`${process.env.PUBLIC_URL + "/gallery"}`} className="slider_btn_one">
                                More Testimonials
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GalleryContentShort;
